import { IfPermission } from '@app/core/auth/authorization/components/IfPermission';
import { pushTo } from '@app/core/routing';
import { useOwnedStation } from '@app/core/stations/hooks/useOwnedStation';
import { composeRouteGenerator } from '@app/modules/compose/routing/compose-route-generator';
import { useAvailableSocialExportPlatformsForStation } from '@app/modules/social-export/hooks/useAvailableSocialExportPlatformsForStation';
import { PublishPlatformMenu } from '@app/modules/social-export/publish';
import { fragmentsPermissions } from '@app/modules/fragments/fragments-permissions';

export interface CompositionVideoEditionPublishMenuProps {
  /** Video editor edit id; passed as `editId` query on the composition upload route for preselection. */
  editId: string;
  compositionId: string;
  /** Station of the composition; drives which social platforms are offered. */
  stationId: string | undefined;
  /**
   * When true, only a share icon opens the menu (used next to the “published on …” label on edit cards).
   */
  iconOnly?: boolean;
}

/**
 * "Publicar en" dropdown for a generated composition edit: lists station-connected platforms
 * and opens the composition upload wizard with this edit preselected (parity with fragment edit cards).
 * Hidden for shared stations (social publish is owner-only).
 */
export function CompositionVideoEditionPublishMenu({
  editId,
  compositionId,
  stationId,
  iconOnly = false,
}: CompositionVideoEditionPublishMenuProps) {
  const ownedStation = useOwnedStation(stationId);
  const { platforms: availablePlatforms } = useAvailableSocialExportPlatformsForStation(stationId);

  if (!ownedStation) {
    return null;
  }

  return (
    <IfPermission permission={fragmentsPermissions.Fragments_SocialPublish}>
      <PublishPlatformMenu
        platforms={availablePlatforms}
        iconOnly={iconOnly}
        onSelectPlatform={(platformId) => {
          pushTo(composeRouteGenerator.upload(compositionId, platformId, editId));
        }}
      />
    </IfPermission>
  );
}
